import { PPRD, Text } from "@/components";

export const ApprochablePricing = () => {
  return (
    <div className="mx-auto container flex flex-col gap-10 items-center">
      <Text.Heading className="text-white text-center">
        Approchable Pricing
      </Text.Heading>

      <div className="text-center text-lg md:text-2xl max-w-screen-xl md:px-16 mx-auto">
        Our affordably priced cap tables have saved the startup ecosystem from
        wasting hundreds of thousands of dollars on overpriced software.
        <br />
        <br />
        And now we are working to save money on legal fees.
        <br />
        <br />
        Our service costs as much as ~10 hours of legal work, and comes with a
        cap table.
        <br />
        <br />
        TLDR: We save your company time & money.
      </div>

      <PPRD />
    </div>
  );
};
